<template>
  <div>
    <BuyoutOptionEvent
      :form="form"
      :currencyCodes="currencyCodes"
      :assetComponent="assetComponent"
    />
  </div>
</template>

<script>
import SetBuyout from "../../models/commands/SetBuyout";
import BuyoutOptionEvent from "../forms/options/BuyoutOptionEvent";
import BuyoutOption from "../../../../models/contract/BuyoutOption";

export default {
  components: {
    BuyoutOptionEvent
  },
  props: {
    assetComponent: {
      required: true,
      type: Object
    },
    currencyCodes: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      form: {}
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      let buyout = null;

      if (this.assetComponent.buyout !== null) {
        buyout = this.assetComponent.buyout;
        this.$set(buyout, 'isBuyout', true);
      } else {
        buyout = BuyoutOption.createNew();
        this.$set(buyout, 'isBuyout', false);
      }

      this.form = buyout;
    },
    cancel() {
      this.init();
    },
    save() {
      let buyout = null;
      if (this.form.isBuyout) {
        buyout = BuyoutOption.createFromData(this.form);
      }

      const command = new SetBuyout(this.assetComponent.idInDB, buyout);
      this.$store.commit("eventRegistryPlugin/addOrUpdateCommand", command);
      return true;
    }
  }
};
</script>

<style>
</style>
